module.exports = __webpack_public_path__ + "media/images/arrows/angle-right-a81dc259e185a4c5fea7dc00a8ad33ce.svg";